import { render, staticRenderFns } from "./menu-items.vue?vue&type=template&id=cb184f4c&scoped=true&"
import script from "./menu-items.vue?vue&type=script&lang=ts&"
export * from "./menu-items.vue?vue&type=script&lang=ts&"
import style0 from "./menu-items.vue?vue&type=style&index=0&id=cb184f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb184f4c",
  null
  
)

export default component.exports